import { Pipe, PipeTransform, inject } from '@angular/core';
import { StatusMovimentacaoCadastralManual as Status } from '../../models/movimentacao-cadastral-manual/StatusMovimentacaoCadastralManual';
import { LabelService } from '../../services/label/label.service';

@Pipe({
  name: 'statusMovimentacaoCadastralManual',
})
export class StatusMovimentacaoCadastralManualPipe implements PipeTransform {
  private labelService = inject(LabelService);

  transform(value: Status): unknown {
    return {
      [Status.EmAndamento]: 'Em Andamento',
      [Status.AguardandoProvedor]: this.labelService.get('aguardandoProvedor'),
      [Status.Erro]: 'Erro',
      [Status.Sucesso]: 'Sucesso',
    }[value];
  }
}
